import styled from 'styled-components'

import { color } from 'styles/colors'

const RotateDeviceMessage = () => (
  <S.Container>
    <S.RotateDeviceImg src="/img/rotate-device.png" />
    <S.Title>Rotate</S.Title>
    <S.Description>Rotate the device</S.Description>
    <S.Description>to view this content</S.Description>
  </S.Container>
)

export default RotateDeviceMessage

const S = {
  Container: styled.div`
    padding: 45px 15px 55px;
    text-align: center;
  `,
  RotateDeviceImg: styled.img`
    display: inline-block;
    width: 100%;
    padding: 0 50px 0 50px;
    text-align: center;
  `,
  Title: styled.h1`
    color: ${color('watermarkTitle')};
    font-size: 38px;
  `,
  Description: styled.div`
    color: ${color('watermarkDescription')};
    font-size: 13px;
    font-weight: bold;
    text-transform: uppercase;
  `
}
